/* --------------------------------------------------------------------------------------
   scanActionBar.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const scanActionBarComponent = {
  template: `
  <div class="xrx-action-bar {{vm.getPrimaryBackground()}}">
    <button xw-button class="xrx-action-bar-button-left" glyph="user" ng-click="vm.cancel()">{{vm.sessionDataService.username}}</button>
    <div class="xrx-action-bar-label">{{vm.title}}</div>
    <button xw-button class="xrx-action-bar-button-right" glyph="scan" ng-click="vm.ok()">{{ 'SCAN' | translate }}</button>
  </div>
  `,
  controllerAs: 'vm',
  controller: class actionBarCtrl {
    /*@ngInject*/
    constructor(appSettings, sessionDataService) {
      this.appSettings = appSettings
      this.sessionDataService = sessionDataService
    }
    getPrimaryBackground() {
      if (this.background == 'primary')
        return "xrx-background " + this.appSettings.primaryColor
    }
  },
  bindings: {
    title: '@',
    cancel: '&',
    ok: '&',
    disableOk: '<',
    background: '@'
  }
}



// WEBPACK FOOTER //
// ./src/app/scan/components/scanActionBar.component.js